// Generated by CoffeeScript 2.7.0
var File;

import Base from './base.js';

export default File = (function() {
  class File extends Base {};

  File.prototype.availableLayouts = ['block'];

  return File;

}).call(this);
